export const mediaList = [
  {
    id: "chang-ye-de-ji-jie",
    title: "漫长的季节",
    enTitle: "The Long Season",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%2C%20lonely%20middle%20aged%20man%20standing%20on%20snowy%20railway%20tracks%20in%201990s%20northeastern%20industrial%20town%20winter%20dusk%2C%20moody%20amber%20and%20teal%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-changye-2024&orientation=portrait",
    year: 2023,
    type: "电视剧",
    region: "国产",
    genres: ["悬疑", "家庭", "年代"],
    rating: 9.4,
    director: "辛爽",
    actors: ["范伟", "秦昊", "陈明昊"],
    duration: "12 集",
    views: 18200000,
    updatedAt: "2023-05-12",
    synopsis:
      "1997 年的东北小城桦林，一桩碎尸案打破平静，工厂司机王响的人生就此改写。二十年光阴流转，当年的谜团在时代的褶皱里缓缓浮出水面。剧集以温柔而克制的笔触，写尽小人物在命运洪流中的挣扎与和解。",
  },
  {
    id: "kuang-biao",
    title: "狂飙",
    enTitle: "The Knockout",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20poster%2C%20man%20in%20leather%20jacket%20standing%20under%20neon%20alley%20lights%20at%20rainy%20night%2C%20dramatic%20hard%20shadows%2C%20moody%20contrast%2C%20no%20text&width=600&height=900&seq=poster-kuangbiao-2024&orientation=portrait",
    year: 2023,
    type: "电视剧",
    region: "国产",
    genres: ["犯罪", "剧情", "悬疑"],
    rating: 8.5,
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐"],
    duration: "39 集",
    views: 25600000,
    updatedAt: "2023-02-08",
    synopsis:
      "一名基层刑警与一个逐渐滑向深渊的鱼贩，在二十年的漫长岁月里彼此追逐。剧集以编年史般的结构，勾勒出扫黑除恶斗争中正义与欲望的正面交锋，被誉为近年国产犯罪题材的代表作。",
  },
  {
    id: "san-ti",
    title: "三体",
    enTitle: "Three-Body",
    cover: "https://readdy.ai/api/search-image?query=sci-fi%20series%20poster%2C%20giant%20planet%20and%20huge%20satellite%20dish%20under%20starry%20cosmic%20sky%2C%20lone%20figure%20silhouette%2C%20deep%20blue%20tones%2C%20epic%20scale%2C%20no%20text&width=600&height=900&seq=poster-santi-2024&orientation=portrait",
    year: 2023,
    type: "电视剧",
    region: "国产",
    genres: ["科幻", "悬疑", "剧情"],
    rating: 8.7,
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾"],
    duration: "30 集",
    views: 21000000,
    updatedAt: "2023-02-03",
    synopsis:
      "纳米物理学家汪淼与刑警史强联手，调查一连串离奇科学家死亡事件，逐步揭开一个跨越星际的文明危机。剧集忠实还原刘慈欣原著的宏大想象，把东方哲学与硬核科幻熔于一炉。",
  },
  {
    id: "yin-mi-de-jiao-luo",
    title: "隐秘的角落",
    enTitle: "The Bad Kids",
    cover: "https://readdy.ai/api/search-image?query=eerie%20family%20thriller%20poster%2C%20child%20silhouette%20standing%20on%20rooftop%20at%20dusk%2C%20dim%20seaside%20town%2C%20unsettling%20atmosphere%2C%20muted%20green%20tones%2C%20no%20text&width=600&height=900&seq=poster-yinmi-2024&orientation=portrait",
    year: 2020,
    type: "电视剧",
    region: "国产",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.8,
    director: "辛爽",
    actors: ["秦昊", "王景春", "荣梓杉"],
    duration: "12 集",
    views: 16400000,
    updatedAt: "2020-06-16",
    synopsis:
      "三个孩子在景区无意间拍下一场谋杀，从此被卷入成年人世界的算计与谎言。一桩罪案牵出一座沿海小城的暗流，剧集以少年视角窥探人性的幽暗角落，克制又冰冷。",
  },
  {
    id: "jue-xing-nian-dai",
    title: "觉醒年代",
    enTitle: "The Awakening Age",
    cover: "https://readdy.ai/api/search-image?query=historical%20drama%20poster%2C%20young%20scholars%20in%20early%2020th%20century%20Chinese%20clothing%20gathered%20in%20lecture%20hall%2C%20warm%20sepia%20light%2C%20dignified%20and%20hopeful%2C%20no%20text&width=600&height=900&seq=poster-juexing-2024&orientation=portrait",
    year: 2021,
    type: "电视剧",
    region: "国产",
    genres: ["历史", "剧情"],
    rating: 9.3,
    director: "张永新",
    actors: ["于和伟", "张桐", "马少骅"],
    duration: "43 集",
    views: 15800000,
    updatedAt: "2021-02-01",
    synopsis:
      "以《新青年》杂志为线索，再现百年前一批热血志士探索救国道路的思想激荡。剧集把宏大叙事落在鲜活的人物与日常细节中，让历史有了温度与呼吸。",
  },
  {
    id: "ren-shi-jian",
    title: "人世间",
    enTitle: "A Lifelong Journey",
    cover: "https://readdy.ai/api/search-image?query=family%20saga%20poster%2C%20three%20generations%20of%20a%20Chinese%20family%20portrait%20in%20old%20courtyard%2C%20warm%20nostalgic%20tones%2C%201970s%20era%20clothing%2C%20soft%20light%2C%20no%20text&width=600&height=900&seq=poster-renshijian-2024&orientation=portrait",
    year: 2022,
    type: "电视剧",
    region: "国产",
    genres: ["家庭", "剧情", "年代"],
    rating: 8.1,
    director: "李路",
    actors: ["雷佳音", "辛柏青", "宋佳"],
    duration: "58 集",
    views: 14300000,
    updatedAt: "2022-01-28",
    synopsis:
      "周家三代人的命运在半个世纪的东北变迁中徐徐展开。剧集以普通家庭的聚散离合为镜，照见时代如何塑造个体，也照见个体如何在时代里坚韧生长。",
  },
  {
    id: "shan-hai-qing",
    title: "山海情",
    enTitle: "Minning Town",
    cover: "https://readdy.ai/api/search-image?query=rural%20drama%20poster%2C%20farmers%20and%20terraced%20fields%20in%20arid%20northwest%20China%2C%20warm%20earthy%20golden%20tones%2C%20hopeful%20and%20sunlit%2C%20no%20text&width=600&height=900&seq=poster-shanhai-2024&orientation=portrait",
    year: 2021,
    type: "电视剧",
    region: "国产",
    genres: ["剧情", "年代"],
    rating: 9.2,
    director: "孔笙",
    actors: ["黄轩", "张嘉益", "闫妮"],
    duration: "23 集",
    views: 11200000,
    updatedAt: "2021-01-12",
    synopsis:
      "从西海固到闽宁镇，一群移民用二十年时间把飞沙走石的戈壁滩建成塞上绿洲。剧集质朴而滚烫，讲的是一个关于希望与坚持的当代故事。",
  },
  {
    id: "liu-lang-di-qiu-2",
    title: "流浪地球 2",
    enTitle: "The Wandering Earth II",
    cover: "https://readdy.ai/api/search-image?query=epic%20sci-fi%20poster%2C%20giant%20space%20elevator%20and%20earth%20engine%20under%20frozen%20sky%2C%20astronauts%20in%20suits%2C%20cold%20blue%20and%20warm%20orange%20contrast%2C%20no%20text&width=600&height=900&seq=poster-wandering2-2024&orientation=portrait",
    year: 2023,
    type: "电影",
    region: "国产",
    genres: ["科幻", "冒险", "剧情"],
    rating: 8.3,
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    duration: "173 分钟",
    views: 27800000,
    updatedAt: "2023-01-22",
    synopsis:
      "在太阳危机全面爆发的年代，人类为延续文明而启动移山计划。影片以前传形式展开，用硬核的工业想象与磅礴的视觉奇观，讲述普通人如何在绝境中选择担当。",
  },
  {
    id: "ni-hao-li-huan-ying",
    title: "你好，李焕英",
    enTitle: "Hi, Mom",
    cover: "https://readdy.ai/api/search-image?query=warm%20nostalgic%20comedy%20poster%2C%20mother%20and%20daughter%20embracing%20in%201980s%20Chinese%20factory%20setting%2C%20soft%20golden%20light%2C%20tender%20and%20heartwarming%2C%20no%20text&width=600&height=900&seq=poster-lihuanying-2024&orientation=portrait",
    year: 2021,
    type: "电影",
    region: "国产",
    genres: ["喜剧", "家庭", "奇幻"],
    rating: 7.7,
    director: "贾玲",
    actors: ["贾玲", "张小斐", "沈腾"],
    duration: "128 分钟",
    views: 20100000,
    updatedAt: "2021-02-12",
    synopsis:
      "贾晓玲意外穿越回 1981 年，与年轻时的母亲李焕英成为“姐妹”。一场跨越时空的陪伴，让笑与泪交织，也让“子欲养而亲不待”的怅惘直抵人心。",
  },
  {
    id: "chang-jin-hu",
    title: "长津湖",
    enTitle: "The Battle at Lake Changjin",
    cover: "https://readdy.ai/api/search-image?query=war%20film%20poster%2C%20soldiers%20in%20winter%20gear%20marching%20through%20heavy%20snowstorm%20on%20mountain%20pass%2C%20cold%20blue%20grey%20tones%2C%20heroic%20and%20solemn%2C%20no%20text&width=600&height=900&seq=poster-changjinhu-2024&orientation=portrait",
    year: 2021,
    type: "电影",
    region: "国产",
    genres: ["战争", "历史", "剧情"],
    rating: 7.4,
    director: "陈凯歌、徐克、林超贤",
    actors: ["吴京", "易烊千玺", "段奕宏"],
    duration: "176 分钟",
    views: 23400000,
    updatedAt: "2021-09-30",
    synopsis:
      "志愿军战士在极寒的长津湖畔与强敌展开殊死搏斗。影片以磅礴的战争场面和细腻的战友群像，致敬那段冰与火之中的英雄史诗。",
  },
  {
    id: "man-jiang-hong",
    title: "满江红",
    enTitle: "Full River Red",
    cover: "https://readdy.ai/api/search-image?query=ancient%20Chinese%20mystery%20poster%2C%20warrior%20with%20sword%20in%20dim%20traditional%20courtyard%2C%20red%20lanterns%2C%20dramatic%20deep%20shadow%2C%20tense%20atmosphere%2C%20no%20text&width=600&height=900&seq=poster-manjianghong-2024&orientation=portrait",
    year: 2023,
    type: "电影",
    region: "国产",
    genres: ["悬疑", "剧情", "古装"],
    rating: 7.0,
    director: "张艺谋",
    actors: ["沈腾", "易烊千玺", "张译"],
    duration: "159 分钟",
    views: 19800000,
    updatedAt: "2023-01-22",
    synopsis:
      "南宋绍兴年间，一桩命案牵出层层反转的朝堂迷局。小兵与亲兵在深宅大院里步步为营，最终指向一段荡气回肠的家国情怀。",
  },
  {
    id: "feng-shen-di-yi-bu",
    title: "封神第一部",
    enTitle: "Creation of the Gods I",
    cover: "https://readdy.ai/api/search-image?query=ancient%20mythology%20poster%2C%20legendary%20warrior%20and%20mythological%20beast%20in%20grand%20palace%2C%20golden%20dramatic%20light%2C%20epic%20fantasy%20grandeur%2C%20no%20text&width=600&height=900&seq=poster-fengshen-2024&orientation=portrait",
    year: 2023,
    type: "电影",
    region: "国产",
    genres: ["奇幻", "动作", "古装"],
    rating: 7.7,
    director: "乌尔善",
    actors: ["费翔", "李雪健", "黄渤"],
    duration: "148 分钟",
    views: 17600000,
    updatedAt: "2023-07-20",
    synopsis:
      "商王殷寿与狐妖妲己勾结，天下大乱。质子姬发在信仰崩塌后觉醒，踏上一条反抗暴政、寻找自我的道路。恢弘的神话世界由此拉开序幕。",
  },
  {
    id: "o-ben-hai-mo",
    title: "奥本海默",
    enTitle: "Oppenheimer",
    cover: "https://readdy.ai/api/search-image?query=biopic%20poster%2C%20scientist%20silhouette%20before%20fiery%20explosion%20cloud%2C%20dramatic%20orange%20and%20black%20contrast%2C%20cinematic%20portrait%2C%20no%20text&width=600&height=900&seq=poster-oppenheimer-2024&orientation=portrait",
    year: 2023,
    type: "电影",
    region: "海外",
    genres: ["传记", "剧情", "历史"],
    rating: 8.9,
    director: "克里斯托弗·诺兰",
    actors: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙"],
    duration: "180 分钟",
    views: 16900000,
    updatedAt: "2023-08-30",
    synopsis:
      "“原子弹之父”罗伯特·奥本海默的传奇一生在银幕上徐徐展开。影片在科学的辉煌与道德的挣扎之间来回穿梭，追问一个天才如何面对自己创造出的力量。",
  },
  {
    id: "sha-qiu-2",
    title: "沙丘 2",
    enTitle: "Dune: Part Two",
    cover: "https://readdy.ai/api/search-image?query=desert%20sci-fi%20poster%2C%20figure%20walking%20across%20vast%20dune%20under%20twin%20suns%2C%20swirling%20sandstorm%2C%20epic%20scale%20warm%20orange%20tones%2C%20no%20text&width=600&height=900&seq=poster-dune2-2024&orientation=portrait",
    year: 2024,
    type: "电影",
    region: "海外",
    genres: ["科幻", "冒险", "动作"],
    rating: 8.5,
    director: "丹尼斯·维伦纽瓦",
    actors: ["提莫西·查拉梅", "赞达亚", "丽贝卡·弗格森"],
    duration: "166 分钟",
    views: 15200000,
    updatedAt: "2024-03-08",
    synopsis:
      "保罗与弗雷曼人并肩作战，走向复仇与命运交织的道路。影片以极致的声画体验铺陈一场关于信仰、权力与救赎的沙漠史诗。",
  },
  {
    id: "xing-ji-chuan-yue",
    title: "星际穿越",
    enTitle: "Interstellar",
    cover: "https://readdy.ai/api/search-image?query=space%20poster%2C%20astronaut%20before%20giant%20ringed%20planet%20and%20glowing%20black%20hole%2C%20cosmic%20light%2C%20awe%20inspiring%20scale%2C%20no%20text&width=600&height=900&seq=poster-interstellar-2024&orientation=portrait",
    year: 2014,
    type: "电影",
    region: "海外",
    genres: ["科幻", "冒险", "剧情"],
    rating: 9.4,
    director: "克里斯托弗·诺兰",
    actors: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦"],
    duration: "169 分钟",
    views: 22300000,
    updatedAt: "2014-11-12",
    synopsis:
      "地球濒临枯竭，前宇航员库珀穿越虫洞为人类寻找新家园。影片把父女亲情放入浩瀚宇宙的尺度之中，探讨爱与时间的永恒命题。",
  },
  {
    id: "dao-meng-kong-jian",
    title: "盗梦空间",
    enTitle: "Inception",
    cover: "https://readdy.ai/api/search-image?query=surreal%20dream%20poster%2C%20man%20before%20folding%20cityscape%20bending%20like%20a%20dream%2C%20cool%20blue%20tones%2C%20mysterious%20and%20intricate%2C%20no%20text&width=600&height=900&seq=poster-inception-2024&orientation=portrait",
    year: 2010,
    type: "电影",
    region: "海外",
    genres: ["科幻", "悬疑", "动作"],
    rating: 9.4,
    director: "克里斯托弗·诺兰",
    actors: ["莱昂纳多·迪卡普里奥", "约瑟夫·高登-莱维特", "艾伦·佩吉"],
    duration: "148 分钟",
    views: 20700000,
    updatedAt: "2010-09-01",
    synopsis:
      "一群“盗梦者”潜入他人潜意识，执行一场前所未有的植入意念任务。层层嵌套的梦境让现实与幻觉难分真伪，结局至今仍被影迷反复讨论。",
  },
  {
    id: "ji-sheng-chong",
    title: "寄生虫",
    enTitle: "Parasite",
    cover: "https://readdy.ai/api/search-image?query=thriller%20poster%2C%20family%20descending%20modern%20staircase%20into%20deep%20shadow%2C%20stark%20contrast%2C%20greenish%20modern%20house%2C%20tense%20mood%2C%20no%20text&width=600&height=900&seq=poster-parasite-2024&orientation=portrait",
    year: 2019,
    type: "电影",
    region: "海外",
    genres: ["剧情", "悬疑", "黑色幽默"],
    rating: 8.8,
    director: "奉俊昊",
    actors: ["宋康昊", "李善均", "曹如晶"],
    duration: "132 分钟",
    views: 14700000,
    updatedAt: "2019-05-30",
    synopsis:
      "住在半地下室的一家人设法进入富人家工作，看似各取所需的寄生关系却在暴雨之夜崩塌。影片以犀利的阶级寓言，斩获奥斯卡最佳影片。",
  },
  {
    id: "qing-hui-da-1988",
    title: "请回答 1988",
    enTitle: "Reply 1988",
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20drama%20poster%2C%20group%20of%20friends%20laughing%20in%201988%20neighborhood%20alley%2C%20warm%20sunset%20light%2C%20retro%201980s%20everyday%20life%2C%20no%20text&width=600&height=900&seq=poster-1988-2024&orientation=portrait",
    year: 2015,
    type: "电视剧",
    region: "海外",
    genres: ["家庭", "青春", "剧情"],
    rating: 9.7,
    director: "申源浩",
    actors: ["李惠利", "朴宝剑", "柳俊烈"],
    duration: "20 集",
    views: 13300000,
    updatedAt: "2016-01-16",
    synopsis:
      "双门洞五户人家的平凡日常，写满了邻里温情与青春心事。没有惊天动地的情节，却让无数观众在琐碎里找到自己的青春与家。",
  },
  {
    id: "quan-li-de-you-xi",
    title: "权力的游戏",
    enTitle: "Game of Thrones",
    cover: "https://readdy.ai/api/search-image?query=fantasy%20epic%20poster%2C%20throne%20room%20with%20burning%20torches%20and%20dragon%20silhouette%2C%20dark%20dramatic%20medieval%20fantasy%20grandeur%2C%20no%20text&width=600&height=900&seq=poster-got-2024&orientation=portrait",
    year: 2011,
    type: "电视剧",
    region: "海外",
    genres: ["奇幻", "剧情", "冒险"],
    rating: 9.3,
    director: "大卫·贝尼奥夫、D.B.威斯",
    actors: ["艾米莉亚·克拉克", "基特·哈灵顿", "彼特·丁拉基"],
    duration: "8 季",
    views: 26800000,
    updatedAt: "2011-04-17",
    synopsis:
      "七大王国为铁王座明争暗斗，长城之外更潜伏着古老的威胁。剧集以庞大群像与残酷权谋，重新定义了史诗奇幻剧的尺度。",
  },
  {
    id: "guai-qi-wu-yu",
    title: "怪奇物语",
    enTitle: "Stranger Things",
    cover: "https://readdy.ai/api/search-image?query=retro%201980s%20poster%2C%20kids%20on%20bikes%20before%20glowing%20red%20portal%20in%20dark%20forest%2C%20neon%20haze%2C%20sci-fi%20horror%20nostalgia%2C%20no%20text&width=600&height=900&seq=poster-stranger-2024&orientation=portrait",
    year: 2016,
    type: "电视剧",
    region: "海外",
    genres: ["科幻", "悬疑", "恐怖"],
    rating: 8.9,
    director: "达菲兄弟",
    actors: ["米莉·博比·布朗", "芬恩·伍法德", "薇诺娜·瑞德"],
    duration: "4 季",
    views: 19100000,
    updatedAt: "2016-07-15",
    synopsis:
      "小镇男孩失踪，一群孩子发现了一个拥有超能力的神秘女孩，也打开了通往“逆世界”的大门。剧集满是 80 年代的怀旧气息与冒险热血。",
  },
];